
<div class="container">
  <div class="row row-with-bottom-padding">
    <div class="col-md-12">

      <div class="auth-box">

        <!-- logo -->
        <div class="logo-above-auth-box logo-tenant-as-background"></div>

        <!-- content -->
        <div class="auth-box-content-wrapper">

          <!-- invalid link -->
          <div *ngIf="isResetLinkValidationCompleted && !isResetLinkValid">
            <h2>{{ 'reset.linkexpired.title' | translate }}</h2>
            <p>
              {{ 'reset.linkexpired.details' | translate }}
            </p>
            <p>
              <a routerLink='/reset-account' class="btn btn-success">{{ 'reset.linkexpired.resetagain' | translate }}</a>
            </p>
          </div>

          <!-- reset -->
          <div *ngIf="isResetLinkValidationCompleted && isResetLinkValid">
            
            <h1>{{ 'reset.title' | translate }}</h1>

            <app-form-validation [result]="validationResult"></app-form-validation>
            <app-form-error [error]="error"></app-form-error>

            <form [formGroup]="form" (submit)="onSubmit()">
              <div class="form-group">
                <div class="page-form_field -w-legend">
                  <input type="password" formControlName="password" tabindex="1" class="form-control" id="password"
                    placeholder="{{ 'reset.new-password' | translate }}" autocomplete="new-password" />
                  <i class="fa fa-lock"></i>
                </div>
                <span class="page-form_legend">
                  {{'validation.passwordformatmismatch' | translate}}
                </span>
                <button type="submit" tabindex="2" [disabled]="submitting" class="btn btn-lg btn-success btn-block"
                  [ngClass]="{ 'btn-run-progress' : submitting }">
                  {{ 'reset.submit' | translate }}
                </button>
              </div>
            </form>

          </div>

        </div>


    </div>
  </div>
</div>
</div>
